import { render, staticRenderFns } from "./Countries.vue?vue&type=template&id=0cb6370b&scoped=true&"
import script from "./Countries.vue?vue&type=script&lang=ts&"
export * from "./Countries.vue?vue&type=script&lang=ts&"
import style0 from "./Countries.vue?vue&type=style&index=0&id=0cb6370b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6370b",
  null
  
)

export default component.exports